import React from "react"

import ColorPicker from "../ColorPicker/ColorPicker"
import LexicalEditorDropdown from "../LexicalEditorDropdown/LexicalEditorDropdown"

interface IDropdownColorPicker {
  disabled?: boolean
  buttonAriaLabel?: string
  buttonClassName: string
  buttonIconClassName?: string
  buttonLabel?: string
  title?: string
  stopCloseOnClickSelf?: boolean
  color: string
  onChange?: (color: string, skipHistoryStack: boolean, skipRefocus: boolean) => void
  setIsColorPickerOpen: (isOpen: boolean) => void
}

const DropdownColorPicker = ({
  disabled = false,
  stopCloseOnClickSelf = true,
  color,
  onChange,
  setIsColorPickerOpen,
  ...rest
}: IDropdownColorPicker) => (
  <LexicalEditorDropdown
    {...rest}
    disabled={disabled}
    stopCloseOnClickSelf={stopCloseOnClickSelf}
    setIsColorPickerOpen={setIsColorPickerOpen}
  >
    <ColorPicker color={color} onChange={onChange} />
  </LexicalEditorDropdown>
)

export default DropdownColorPicker
